module.exports = __webpack_public_path__ + "static/media/jg.d41d8cd9.svg";